import showSnackbar from 'shared/snackbar';

export default function ErrorHandling(enqueueSnackbar) {
  return error => {
    const message =
      error?.errors?.[0]?.message ||
      error?.message ||
      'Não conseguimos acessar o servidor.';
    showSnackbar({
      message,
      variant: 'error',
      enqueueSnackbar
    });
  };
}
